import type { MarkerNamesByField } from '@core/core/types'
import type { PayloadAction, Update } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

import {
  loadHotStorageFieldsHavingMarkers,
  loadHotStorageMarkerNamesForField,
} from './markerNamesByFieldsActions'

export const markerNamesByFieldAdapter = createEntityAdapter<MarkerNamesByField>({
  selectId: field => field.id,
  sortComparer: (e1, e2) => e1.name.localeCompare(e2.name),
})

const slice = createSlice({
  name: 'markerNamesByField',
  initialState: markerNamesByFieldAdapter.getInitialState(),
  reducers: {
    setFields(state, action: PayloadAction<MarkerNamesByField[]>) {
      markerNamesByFieldAdapter.setMany(state, action.payload)
    },
    updateField(state, action: PayloadAction<Update<MarkerNamesByField>>) {
      markerNamesByFieldAdapter.updateOne(state, action.payload)
    },
    removeAllFields(state) {
      markerNamesByFieldAdapter.removeAll(state)
    },
  },
  extraReducers: builder => {
    builder
      .addCase(loadHotStorageFieldsHavingMarkers.fulfilled, (state, action) => {
        markerNamesByFieldAdapter.setMany(state, action.payload)
      })
      .addCase(loadHotStorageMarkerNamesForField.fulfilled, (state, action) => {
        const { fieldId, markerNames } = action.payload
        markerNamesByFieldAdapter.updateOne(state, { id: fieldId, changes: { markerNames } })
      })
  },
})

export const markerNamesByFieldReducer = slice.reducer
export const markerNamesByFieldActions = slice.actions
